module.exports = __webpack_public_path__ + "img/toolbar_messages_envelope.35ef53f7.png";